import * as React from 'react'
import { InnerContainer, PrimaryText, Reg, StrongText, Text } from '../../../../../shared/components/Elements'
import { HeadlineCSS } from '../../../../../shared/components/Headlines'
import { breakpoint, styled } from '../../../../../shared/styled-components'
import { Utils } from '../../../../../shared/Utils'
import { Insurance } from './Insurance'

interface IProps {
  selfExpense: number
}

export const InsuranceSuggestions = ({ selfExpense }: IProps) => {
  return (
    <Container>
      <InnerContainer>
        <Header>
          <Logo src={Utils.getAssetPath('/assets/calculator/result/badge.svg')} />
          <HeaderContent>
            <Headline>Hohe Kosten für Zahnersatz und Zahnbehandlungen vermeiden?</Headline>
            <HeaderText>
              Das funktioniert mit einer passenden Zahnzusatzversicherung. Wir beraten Sie gerne und unabhängig.
            </HeaderText>
          </HeaderContent>
        </Header>
        <Insurances>
          <Insurance
            layout="white"
            name="Komfort"
            percentage={70}
            selfExpense={selfExpense}
            price={14}
            link="https://implacare.de/komfort"
          />
          <Insurance
            layout="green"
            name="Premium"
            percentage={90}
            selfExpense={selfExpense}
            price={18}
            link="https://implacare.de/premium"
          />
          <Insurance
            layout="dark"
            name="Exklusiv"
            percentage={100}
            selfExpense={selfExpense}
            price={20}
            link="https://implacare.de/exklusiv"
            recommended
          />
        </Insurances>
      </InnerContainer>
    </Container>
  )
}

const Container = styled.div`
  position: relative;
  background: ${(props) => props.theme.blueColor};
  margin-top: 3rem;
  padding-bottom: 60px;
  background-size: cover;
  background-image: url(${Utils.getAssetPath('https://implacheck.de/img/insurrance-bg.png')});
  @media print { 
  display: none;
  }
`

const Header = styled.div`
  position: relative;
  z-index: 2;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 20px;
  ${breakpoint('tablet')`
    flex-direction: row;
    height: 300px;
    padding: 65px 50px;
  `}
`

const Logo = styled.img`
  margin: 0 auto 20px auto;
  width: 60px;
  ${breakpoint('tablet')`
    margin: 0 35px 0 0;
  `}
`

const Headline = styled.h2`
  ${HeadlineCSS};
  font-size: 20px;
  margin-bottom: 10px;
  color: white;
  ${breakpoint('tablet')`
    font-size: 20px !important;
    margin-bottom: 30px;
  `}
`

const HeaderContent = styled.div`
  display: flex;
  flex-direction: column;
  ${breakpoint('tablet')`
    flex: 0 0 355px;
  `}
`

const Insurances = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column-reverse;
  align-items: stretch;
  padding: 0 15px;
  column-gap: 30px;
  ${breakpoint('tablet')`
    flex-direction: row;
  `}
`

const HeaderText = styled.div`
  color: ${(props) => props.theme.greenColor};
  @media (max-width: 950px) {
    margin-bottom: 30px;
  }
`
